export const SIGNUP_REQUEST = 'SIGNUP_REQUEST';
export const SIGNUP_SUCCESS = 'SIGNUP_SUCCESS';
export const SIGNUP_FAILURE = 'SIGNUP_FAILURE';

export const VERIFY_OTP_REQUEST = 'VERIFY_OTP_REQUEST';

export const RESEND_OTP_REQUEST = 'RESEND_OTP_REQUEST';
export const RESEND_OTP_SUCCESS = 'RESEND_OTP_SUCCESS';
export const RESEND_OTP_FAILURE = 'RESEND_OTP_FAILURE';

export const VERIFY_INVITE_TOKEN = 'VERIFY_INVITE_TOKEN';
export const VERIFY_INVITE_TOKEN_SUCCESS = 'VERIFY_INVITE_TOKEN_SUCCESS';
export const VERIFY_INVITE_TOKEN_FAILURE = 'VERIFY_INVITE_TOKEN_FAILURE';

export const RESET_INVITE_REQUEST = 'RESET_INVITE_REQUEST';
